import { useTranslation } from 'react-i18next'

export const CustomCssPreviewBanner = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div
      aria-label={t('consumer.preview.topBar.ariaLabel')}
      className="flex items-center justify-center px-4 py-1.5 text-body3 font-semibold bg-neutral-95 dark:bg-neutral-50 text-neutral-10 dark:text-neutral-98"
      data-testid="custom-css-preview-banner"
    >
      {t('consumer.preview.topBar.customCss.badge')}
    </div>
  )
}
